import '../scss/contact.scss';

import domSlider from 'dom-slider';
import formTracking from './scripts/form-tracking';

window.addEventListener("DOMContentLoaded", function(event) {
	const { slideDown, slideUp } = window.domSlider

	const triggers = document.querySelectorAll('button[data-target]');
	const businessTarget = document.querySelector('section[data-target="business"]');
	const consumerTarget = document.querySelector('section[data-target="consumer"]');
	const mainElement = document.querySelector('main');
	const headerMessage = document.querySelector('.page-header > div > p');
	const OnLoadTriggeredByBusiness = document.querySelector('.contact-form.open-on-load') ? true : false;
	const OnLoadTriggeredByConsumer = document.querySelector('.contact-redirect.open-on-load') ? true : false;
	// get url parameter by name
	// interested-in-dressings-sauces

	if (triggers && businessTarget && consumerTarget && mainElement) {
		triggers.forEach(trigger => {
			trigger.addEventListener('click', function(e) {
				triggers.forEach(trigger => trigger.classList.remove('active'));
				trigger.classList.add('active');
				if (e.target.dataset.target === 'business') {
					// businessTarget.classList.add('active');
					// consumerTarget.classList.remove('active');
					slideDown({element: businessTarget, slideSpeed: 800, visibleDisplayValue: 'flex'})
					slideUp({element: consumerTarget, slideSpeed: 200, visibleDisplayValue: 'flex'})
					if( headerMessage ) {
						slideDown({element: headerMessage, slideSpeed: 400, visibleDisplayValue: 'block'})
					}
					mainElement.classList.remove('redirect-active');
				} else if (e.target.dataset.target === 'consumer') {
					slideDown({element: consumerTarget, slideSpeed: 800, visibleDisplayValue: 'flex'})
					slideUp({element: businessTarget, slideSpeed: 200, visibleDisplayValue: 'flex'})
					if( headerMessage ) {
						slideUp({element: headerMessage, slideSpeed: 200, visibleDisplayValue: 'block'})
					}
					// businessTarget.classList.remove('active');
					// consumerTarget.classList.add('active');
					mainElement.classList.add('redirect-active');
				}
				if (typeof dataLayer !== 'undefined') {
					dataLayer.push({
						'event': 'form-selection',
						'form_choice': e.target.dataset.target
					});
				}
			})
		})
	}
	if (OnLoadTriggeredByBusiness) {
	}
	if (OnLoadTriggeredByConsumer) {
		if( headerMessage ) {
			headerMessage.style.display = 'none';
		}
		mainElement.classList.add('redirect-active');
	}
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('preselect')) {
		const preselect = urlParams.get('preselect');
		let preselectTrigger = null;
		if (preselect) {
			preselectTrigger = document.querySelector(`input[data-fui-id="contact-form-${preselect}"]`);
		}
		if (preselectTrigger) {
			preselectTrigger.click();
		}
	}


	// this is a fix for some weird issues with the Gotham font and labels with spans inside them. The spans come from marking a Formie field as required and spans get added with asterisks, as well as non breaking spaces right before them. They were causing the asterisks to be pushed over to the right. This script filters all the text in the lables and removes any non-breaking spaces. 
	const labels = document.querySelectorAll('.fui-label');
	if (labels) {
		labels.forEach(label => {
			let text = label.innerHTML.replace(/\&nbsp;/g, '');
			label.innerHTML = text;
		})
	}
});

formTracking();